import React from 'react';
import HomeIcon from '@mui/icons-material/Home';
import LocalPostOfficeIcon from '@mui/icons-material/LocalPostOffice';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import IconBoxReturn from '../../assets/IconBoxReturn.svg';
import ArchiveRoundedIcon from '@mui/icons-material/ArchiveRounded';
import IconPunctuality from '../../assets/iconPunctuality.svg';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import RouteIcon from '../../assets/routeIcon.svg';
import SupportIcon from '@mui/icons-material/Support';
import DashboardIcon from '@mui/icons-material/Dashboard';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { FaWarehouse } from 'react-icons/fa';

/** Mesmo tamanho visual de antes; repassa className/style do menu para o hover/active funcionar. */
const TransshipmentsSidebarIcon = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => <FaWarehouse ref={ref} size={20} {...props} />
);
TransshipmentsSidebarIcon.displayName = 'TransshipmentsSidebarIcon';

export interface NavItem {
  title: string;
  path?: string | null;
  permissions?: string[];
  icon: any;
  children?: NavItem[];
}

const NavConfig: NavItem[] = [
  {
    title: "Home",
    permissions: [],
    path: "/home",
    icon: HomeIcon,
  },
  {
    title: "Dashboard",
    permissions: ["Admin", "Logística 03"],
    path: "/dashboard",
    icon: DashboardIcon,
  },
  {
    title: "Entregas",
    permissions: ["Admin", "Logística 03"],
    path: "/deliveries",
    icon: LocalPostOfficeIcon,
  },
  {
    title: "Motoristas e Times",
    permissions: ["Admin", "Logística 03"],
    path: "/drivers",
    icon: LocalShippingIcon,
  },
  {
    title: "Motoristas de suporte",
    permissions: ["Admin", "Logística 03"],
    path: "/support-drivers",
    icon: SupportIcon,
  },
  {
    title: "Status de Entregas",
    permissions: ["Admin", "Logística 03"],
    path: "/delivery-status",
    icon: StickyNote2Icon,
  },
  {
    title: "Caixas",
    permissions: ["Admin", "Logística 03", "BoxControl"],
    icon: ArchiveRoundedIcon,
    children: [
      {
        title: "Entrada de Caixas",
        permissions: ["Admin", "Logística 03", "BoxControl"],
        path: "/box-count",
        icon: ArchiveRoundedIcon,
      },
      {
        title: "Devolução de Caixas",
        permissions: ["Admin", "Logística 03", "BoxControl"],
        path: "/box-return",
        icon: () => (<img src={IconBoxReturn} alt="Icon" />),
      }
    ]
  },
  {
    title: "Pontualidade",
    permissions: ["Admin", "Logística 03"],
    path: "/driver-punctuality",
    icon: () => (<img src={IconPunctuality} alt="Icon" />),
  },
  {
    title: "Quebras",
    permissions: ["Admin", "Logística 03"],
    path: "/driver-complaint",
    icon: BrokenImageIcon,
  },
  {
    title: "Transbordos",
    permissions: ["Admin", "Logística 03"],
    path: "/transshipments",
    icon: TransshipmentsSidebarIcon,
  },
  {
    title: "Rotas",
    permissions: ["Admin", "Logística 03"],
    path: "/routes",
    icon: () => (<img src={RouteIcon} alt="Icon" />),
    children: [
      {
        title: "Atribuição",
        permissions: ["Admin", "Logística 03"],
        path: "/routes",
        icon: () => (<img src={RouteIcon} alt="Icon" />),
      },
      {
        title: "Exportação",
        permissions: ["Admin", "Logística 03"],
        path: "/export-routes",
        icon: () => (<img src={RouteIcon} alt="Icon" />),
      },
    ],
  },
  {
    title: "Gestão de Custos",
    permissions: ["Admin", "Logística 03"],
    icon: MonetizationOnIcon,
    children: [
      {
        title: "Last Mile",
        permissions: ["Admin", "Logística 03"],
        path: "/cost-management/last-mile",
        icon: MonetizationOnIcon,
      },
      {
        title: "First Mile",
        permissions: ["Admin", "Logística 03"],
        path: "/cost-management/first-mile",
        icon: MonetizationOnIcon,
      },
      {
        title: "Suporte",
        permissions: ["Admin", "Logística 03"],
        path: "/cost-management/support",
        icon: MonetizationOnIcon,
      },
      {
        title: "Valores base",
        permissions: ["Admin", "Logística 03"],
        path: "/cost-management/default-costs",
        icon: MonetizationOnIcon,
      },
    ]
  },
];

export default NavConfig;
